import { defineStore } from 'pinia';
import { reactive } from 'vue';

export const useRegisterOrderModalStore = defineStore('registerOrderModal', () => {
  const state = reactive<{
    selectedFile?: File;
  }>({
    selectedFile: undefined,
  });

  /**
   * 初期化
   */
  const $reset = () => {
    state.selectedFile = undefined;
  };

  return {
    state,
    $reset,
  };
});
